export const getMinutesAndHoursFromSeconds = (seconds) => {
  const numberSeconds = Number(seconds);

  const h = Math.floor(numberSeconds / 3600);
  const m = Math.floor((numberSeconds % 3600) / 60);

  return { hours: h === 0 ? '0' : String(h), minutes: String(m) };
};
